$(document).ready(function() {
	var spaceBetween = 10;
	var slidewidth = 64;
	if( $(window).width() < 1024 ) {
		spaceBetween = 5;
		slidewidth = 40;
	}

	var maxTireImgPerView = $('.tire_img .thumbs .swiper-slide').length > 5 ? 5 : $('.tire_img .thumbs .swiper-slide').length;
	$('.tire_img .thumbs').css('width', maxTireImgPerView * (slidewidth + spaceBetween) - spaceBetween);
	// console.log("maxTireImgPerViewL : "+ maxTireImgPerView)

	var tireImgThumbs = new Swiper('.tire_img .thumbs', {
		spaceBetween: 5,
		slidesPerView: maxTireImgPerView,
		loop: false,		
		allowTouchMove: false, // 스와이프 X
		loopedSlides: 3, //looped slides should be the same
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
/* 		breakpoints: {
			1024: {
				spaceBetween: 10
			}
		} */

	});
	new Swiper('.tire_img .top', {
		loop:false,
		loopedSlides: 3, //looped slides should be the same
		navigation: {
			nextEl: '.tire_img .swiper-button-next',
			prevEl: '.tire_img .swiper-button-prev'
		},
		thumbs: { swiper: tireImgThumbs }
	});
	/* ================ zoom ====================== */
	$('.js-zoom').jzoom({bgColor: "#fff", width: 300, height: 300, position:"right", opacity:0 });

	

	$(window).on('resize',function() {
		if( $(window).width() < 1024 ) {
			spaceBetween = 5;
			slidewidth = 40;
		}else{
			spaceBetween = 10;
			slidewidth = 64;
		}
		var _size  =  maxTireImgPerView * (slidewidth + spaceBetween) - spaceBetween;
		$('.tire_img .thumbs').css({ width:_size, height:_size });
	}).trigger('resize');




}); //ready




/* =========================================== 매장 찾기  =========================================== */
function reloadBranchSlider($this){
	var t = $this; //$('.branch_box-list .store_search-list li').eq(idx);
	if( t.find('.branch-slider').length > 0 ) {
		setTimeout(function() {
			t.find('.branch-slider').data('swiper').update();
		},100);
		// trpaccordion callback 함수이나, 선 실행되는 문제로 timeout 후 실행하도록 settimeout 실행
	}
	return true;
}


/* =========================================== 타이어검색  =========================================== */
function makeTireSearchSelect($this, data, footer)
{      
	var t = $($this),
		parent = t.data('parent'),
		labeltxt = $('label[for='+parent+']').text(),		
		orival,oridata,reset= false;
	var footer = footer ? true : false;

	if (t.hasClass("select2-hidden-accessible")) {
		// Select2 has been initialized
		// data 미리 보관
		orival = t.val();
		oridata = t.data('data');
		/// console.log(oridata);
		t.select2("destroy");
		reset = true;
	}
	//console.log("labeltxt: "+ labeltxt)
	var options = {
		width:'100%',
		minimumResultsForSearch: Infinity,
		dropdownParent: t.closest('.select-box'),
		closeOnSelect: false,
		dropdownPosition:'below',
		//dropdownCssClass:'fixed_dropdown',
		escapeMarkup: function (markup) { return markup; },
		language: {
			noResults: function(){
				//return '<p><i class="icon-search_empty"></i>'+' Please select the <br> '+ labeltxt +'</p>';
				return '<p><i class="icon-search_empty"></i>'+'请选择 <br> '+ labeltxt +'</p>';
			}
		},
		tags:true
	};
	if( $('body').hasClass('is_mb') || footer ) {
		// mobile 일 경우, select2 기본값을 변경함
		options.dropdownCssClass = '';
		options.dropdownPosition = '';
		options.closeOnSelect = true;
		options.placeholder = ' Please select the ' + labeltxt;

		if( footer ) options.dropdownParent= $(document.body);
	}

	
	if( data ) {
		options.data = data;
		t.data('data', data);
		if( data[0] && data[0].icon ) {
			options.templateResult = formatOption
		}
	} else if( oridata && reset ) {
		options.data = oridata;
		if( oridata[0] && oridata[0].icon ) {
			options.templateResult = formatOption
		}
	}

	var list = t.select2(options);
	if( $('body').hasClass('is_pc') && footer == false ) { 
		// pc 일 경우 select2 동작을 막음.
		list.on("select2:closing", function(e) {
			e.preventDefault();
		}).on("select2:closed", function(e) {
			list.select2("open");
		});
		list.select2("open"); 
	} else {
		list.off("select2:closing").off("select2:closed");
		list.select2("close"); 
	}
	t.closest('.select-box').find('.select2-results__options').mCustomScrollbar();
	// option 갯수가 없으면 tire_option-empty class 추가
	if( list.find('option').length == 0 ) t.closest('.select-box').addClass('tire_option-empty');
	else t.closest('.select-box').removeClass('tire_option-empty');

	if( orival ) t.val(orival).trigger("change");
}

function makeTireSearchSelect_lang($this, data, $lang, $lang_mb)
{      
	var t = $($this),
		parent = t.data('parent'),
		labeltxt = $('label[for='+parent+']').text(),		
		orival,oridata,reset= false;
	var footer = footer ? true : false;

	if (t.hasClass("select2-hidden-accessible")) {
		// Select2 has been initialized
		// data 미리 보관
		orival = t.val();
		oridata = t.data('data');
		/// console.log(oridata);
		t.select2("destroy");
		reset = true;
	}

	var options = {
		width:'100%',
		minimumResultsForSearch: Infinity,
		dropdownParent: t.closest('.select-box'),
		closeOnSelect: false,
		dropdownPosition:'below',
		//dropdownCssClass:'fixed_dropdown',
		escapeMarkup: function (markup) { return markup; },
		language: {
			noResults: function(){
				return '<p><i class="icon-search_empty"></i>'+ $lang +'</p>';
			}
		},
		tags:true
	};
	if( $('body').hasClass('is_mb') || footer ) {
		// mobile 일 경우, select2 기본값을 변경함
		options.dropdownCssClass = '';
		options.dropdownPosition = '';
		options.closeOnSelect = true;
		//options.placeholder = Josa.r(labeltxt,'을/를')+' 선택해주세요.';
		options.placeholder = $lang_mb;

		if( footer ) options.dropdownParent= $(document.body);
	}

	
	if( data ) {
		options.data = data;
		t.data('data', data);
		if( data[0] && data[0].icon ) {
			options.templateResult = formatOption
		}
	} else if( oridata && reset ) {
		options.data = oridata;
		if( oridata[0] && oridata[0].icon ) {
			options.templateResult = formatOption
		}
	}

	var list = t.select2(options);
	if( $('body').hasClass('is_pc') && footer == false ) { 
		// pc 일 경우 select2 동작을 막음.
		list.on("select2:closing", function(e) {
			e.preventDefault();
		}).on("select2:closed", function(e) {
			list.select2("open");
		});
		list.select2("open"); 
	} else {
		list.off("select2:closing").off("select2:closed");
		list.select2("close"); 
	}
	t.closest('.select-box').find('.select2-results__options').mCustomScrollbar();
	// option 갯수가 없으면 tire_option-empty class 추가
	if( list.find('option').length == 0 ) t.closest('.select-box').addClass('tire_option-empty');
	else t.closest('.select-box').removeClass('tire_option-empty');

	if( orival ) t.val(orival).trigger("change");
}


function formatOption(state) {  console.log("state : " +state)
	console.log(state);
	// 모바일은 아이콘 제공 안함.
	if( ! state.icon || $('body').hasClass('is_mo')) return state.text;

	var $state = $(
		'<p class="tire-icon_option  '+ state.class+'  " ><span></span><i></i></p>'
	);
	

	// Use .text() instead of HTML string concatenation to avoid script injection issues
	$state.find("span").text(state.text);
	$state.find("i").addClass('icon_tire-'+state.icon+'-'+state.id);

	return $state;
};

(function(){ 

	var	_f = [
		function(string) { //을/를 구분
			return _hasJong(string) ? '을' : '를';
		},
		function(string){ //은/는 구분
			return _hasJong(string) ? '은' : '는';
		},
		function(string){ //이/가 구분
			return _hasJong(string) ? '이' : '가';
		},
		function(string){ //와/과 구분
			return _hasJong(string) ? '과' : '와';
		}
	],
		_formats = {
			'을/를' : _f[0],
			'을' : _f[0],
			'를' : _f[0],
			'을를' : _f[0],
			'은/는' : _f[1],
			'은' : _f[1],
			'는' : _f[1],
			'은는' : _f[1],
			'이/가' : _f[2],
			'이' : _f[2],
			'가' : _f[2],
			'이가' : _f[2],
			'와/과' : _f[3],
			'와' : _f[3],
			'과' : _f[3],
			'와과' : _f[3]
		};

	function _hasJong(string){ //string의 마지막 글자가 받침을 가지는지 확인
		string = string.charCodeAt(string.length - 1);
		return (string - 0xac00) % 28 > 0;
	}

	var josa = {
		c: function(word, format){
			if (typeof _formats[format] === 'undefined') throw 'Invalid format!';
			return _formats[format](word);
		},
		r: function(word, format) {
			return word + josa.c(word, format);
		}
	};

	if (typeof define == 'function' && define.amd) {
		define(function(){
			return josa;
		});
	} else if (typeof module !== 'undefined') {
		module.exports = josa;
	} else {
		window.Josa = josa;
	}
})(1);
